/* This component is loaded only by the Handyketten collection. Facet values
   come from explicit product tags, including all colors of grouped products. */
(() => {
  if (customElements.get('handyketten-filters')) return;
  const FACETS = {
    hooks: { prefix: 'Hakenanzahl: ', param: 'haken' },
    color: { prefix: 'Bandfarbe: ', param: 'bandfarbe' },
    thickness: { prefix: 'Banddicke: ', param: 'banddicke' },
    metal: { prefix: 'Hakenfarbe: ', param: 'hakenfarbe' }
  };
  const KEYS = Object.keys(FACETS);
  const TEXT = {
    de: { filters:'Handyketten filtern',hooks:'Hakenanzahl',color:'Bandfarbe',thickness:'Banddicke',metal:'Hakenfarbe',searchColor:'Bandfarbe suchen',loading:'Produkte werden geladen…',clear:'Alle Filter löschen',sort:'Sortieren',recommended:'Empfohlen',priceAsc:'Preis aufsteigend',priceDesc:'Preis absteigend',newest:'Neueste',products:'{count} Produkte',filtered:'{count} von {total} Produkten',empty:'Keine Handyketten für diese Kombination gefunden.',error:'Die Handyketten konnten nicht geladen werden.',retry:'Erneut laden',from:'ab',hookOne:'1 Haken',hookTwo:'2 Haken',remove:'entfernen',pages:'Produktseiten',page:'Seite',previous:'Vorherige Seite',next:'Nächste Seite' },
    en: { filters:'Filter phone straps',hooks:'Number of hooks',color:'Strap color',thickness:'Strap thickness',metal:'Hook color',searchColor:'Search strap color',loading:'Loading products…',clear:'Clear all filters',sort:'Sort',recommended:'Recommended',priceAsc:'Price: low to high',priceDesc:'Price: high to low',newest:'Newest',products:'{count} products',filtered:'{count} of {total} products',empty:'No phone straps match this combination.',error:'Phone straps could not be loaded.',retry:'Try again',from:'from',hookOne:'1 hook',hookTwo:'2 hooks',remove:'remove',pages:'Product pages',page:'Page',previous:'Previous page',next:'Next page' },
    fr: { filters:'Filtrer les cordons',hooks:'Nombre de mousquetons',color:'Couleur du cordon',thickness:'Épaisseur du cordon',metal:'Couleur des mousquetons',searchColor:'Rechercher une couleur',loading:'Chargement des produits…',clear:'Effacer tous les filtres',sort:'Trier',recommended:'Recommandé',priceAsc:'Prix croissant',priceDesc:'Prix décroissant',newest:'Nouveautés',products:'{count} produits',filtered:'{count} produits sur {total}',empty:'Aucun cordon ne correspond à cette combinaison.',error:'Impossible de charger les cordons.',retry:'Réessayer',from:'dès',hookOne:'1 mousqueton',hookTwo:'2 mousquetons',remove:'supprimer',pages:'Pages de produits',page:'Page',previous:'Page précédente',next:'Page suivante' }
  };
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  class HandykettenFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.lang = document.documentElement.lang.slice(0, 2).toLowerCase();
      if (!TEXT[this.lang]) this.lang = 'de';
      this.pageSize = Math.max(8, Number(this.dataset.pageSize) || 24);
      this.collectionUrl = this.dataset.collectionUrl;
      this.products = [];
      this.options = {};
      this.abort = new AbortController();
      this.$ = selector => this.querySelector(selector);
      this.querySelectorAll('[data-hk-i18n]').forEach(el => { el.textContent = this.t(el.dataset.hkI18n); });
      this.querySelectorAll('[data-hk-aria]').forEach(el => el.setAttribute('aria-label', this.t(el.dataset.hkAria)));
      this.querySelectorAll('[data-hk-placeholder]').forEach(el => { el.placeholder = this.t(el.dataset.hkPlaceholder); });
      this.readUrl();
      this.bindEvents();
      this.load();
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
    t(key, vars = {}) { return Object.entries(vars).reduce((text, [name, value]) => text.replace('{'+name+'}', value), TEXT[this.lang][key] || key); }
    label(key, value) {
      if (key === 'hooks') return this.t(value === '1' ? 'hookOne' : 'hookTwo');
      if (key === 'thickness') return value.replace('mm', ' mm');
      return value;
    }
    readUrl() {
      const params = new URLSearchParams(location.search);
      this.state = Object.fromEntries(KEYS.map(key => [key, [...new Set(params.getAll(FACETS[key].param))]]));
      this.sort = ['relevance','price-asc','price-desc','newest'].includes(params.get('sort')) ? params.get('sort') : 'relevance';
      this.page = Math.max(1, parseInt(params.get('page'), 10) || 1);
    }
    writeUrl(mode) {
      const url = new URL(location.href);
      KEYS.forEach(key => {
        url.searchParams.delete(FACETS[key].param);
        this.state[key].forEach(value => url.searchParams.append(FACETS[key].param, value));
      });
      url.searchParams.delete('sort');
      url.searchParams.delete('page');
      if (this.sort !== 'relevance') url.searchParams.set('sort', this.sort);
      if (this.page > 1) url.searchParams.set('page', this.page);
      if (url.href !== location.href) history[mode === 'push' ? 'pushState' : 'replaceState'](null, '', url);
    }
    bindEvents() {
      const on = (target, type, handler) => target.addEventListener(type, handler, {signal:this.abort.signal});
      on(this, 'change', event => {
        const input = event.target;
        if (input.matches('[data-hk-facet]')) {
          const key = input.dataset.hkFacet;
          this.state[key] = Array.from(this.querySelectorAll('[data-hk-facet="'+key+'"]:checked'), el => el.value);
          this.page = 1;
          this.render('push');
        } else if (input.matches('[data-hk-sort]')) {
          this.sort = input.value;
          this.page = 1;
          this.render('push');
        }
      });
      on(this.$('[data-hk-search]'), 'input', () => this.searchColors());
      on(this, 'click', event => {
        const clear = event.target.closest('[data-hk-clear]');
        const chip = event.target.closest('[data-hk-remove]');
        const page = event.target.closest('[data-hk-page]');
        if (clear) {
          KEYS.forEach(key => { this.state[key] = []; });
          this.$('[data-hk-search]').value = '';
          this.searchColors();
          this.page = 1;
          this.render('push');
          this.$('summary').focus();
        } else if (chip) {
          this.state[chip.dataset.hkRemove] = this.state[chip.dataset.hkRemove].filter(value => value !== chip.dataset.value);
          this.page = 1;
          this.render('push');
          this.$('summary').focus();
        } else if (page && !page.disabled) {
          this.page = Number(page.dataset.hkPage);
          this.render('push');
          this.$('[data-hk-count]').scrollIntoView({block:'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          this.$('[data-hk-pages] [aria-current="page"]')?.focus({preventScroll:true});
        } else if (event.target.closest('[data-hk-retry]')) this.load();
      });
      this.querySelectorAll('details').forEach(details => on(details, 'toggle', () => {
        if (details.open) this.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
      }));
      on(document, 'click', event => this.querySelectorAll('details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }));
      on(this, 'keydown', event => {
        if (event.key === 'Escape') this.querySelectorAll('details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
      });
      on(window, 'popstate', () => { this.readUrl(); if (this.loaded) this.render('replace'); });
    }
    async fetchPage(page) {
      const url = new URL(this.collectionUrl, location.origin);
      url.searchParams.set('view', 'handyketten-filter-data');
      url.searchParams.set('page', page);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, {signal:this.abort.signal});
      if (!response.ok) throw new Error('Product feed: '+response.status);
      return response.json();
    }
    async load() {
      this.$('[data-hk-count]').textContent = this.t('loading');
      this.$('[data-hk-results]').setAttribute('aria-busy', 'true');
      try {
        const first = await this.fetchPage(1);
        const rest = await Promise.all(Array.from({length:Math.max(0, first.pages - 1)}, (_, i) => this.fetchPage(i + 2)));
        this.products = [first, ...rest].flatMap(page => page.products).map(product => ({...product, facets:Object.fromEntries(KEYS.map(key => [key, (product.tags || []).filter(tag => tag.startsWith(FACETS[key].prefix)).map(tag => tag.slice(FACETS[key].prefix.length))]))}));
        this.currency = first.currency || 'CHF';
        KEYS.forEach(key => { this.options[key] = [...new Set(this.products.flatMap(product => product.facets[key]))].sort((a,b) => a.localeCompare(b, 'de', {numeric:true})); });
        this.buildOptions();
        this.loaded = true;
        this.$('[data-hk-controls]').disabled = false;
        this.$('[data-hk-sort]').disabled = false;
        this.render('replace');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.$('[data-hk-count]').textContent = this.t('error');
        this.$('[data-hk-grid]').innerHTML = '<div class="hk-empty"><button type="button" class="hk-retry" data-hk-retry>'+escape(this.t('retry'))+'</button></div>';
      } finally { this.$('[data-hk-results]').setAttribute('aria-busy', 'false'); }
    }
    buildOptions() {
      KEYS.forEach(key => {
        this.$('[data-hk-options="'+key+'"]').innerHTML = this.options[key].map(value => '<label class="hk-option"><input type="checkbox" data-hk-facet="'+key+'" value="'+escape(value)+'"><span>'+escape(this.label(key, value))+'</span><span class="hk-option-count" aria-hidden="true"></span></label>').join('');
      });
    }
    searchColors() {
      const search = this.$('[data-hk-search]').value.trim().toLocaleLowerCase(this.lang);
      this.querySelectorAll('[data-hk-options="color"] .hk-option').forEach(label => { label.hidden = !label.querySelector('input').value.toLocaleLowerCase(this.lang).includes(search); });
    }
    matches(product, skip) { return KEYS.every(key => key === skip || !this.state[key].length || this.state[key].some(value => product.facets[key].includes(value))); }
    renderControls() {
      KEYS.forEach(key => {
        const candidates = this.products.filter(product => this.matches(product, key));
        this.$('[data-hk-selected="'+key+'"]').textContent = this.state[key].length ? '('+this.state[key].length+')' : '';
        this.querySelectorAll('[data-hk-facet="'+key+'"]').forEach(input => {
          const count = candidates.filter(product => product.facets[key].includes(input.value)).length;
          input.checked = this.state[key].includes(input.value);
          input.disabled = count === 0 && !input.checked;
          input.closest('label').classList.toggle('is-unavailable', input.disabled);
          input.closest('label').querySelector('.hk-option-count').textContent = '('+count+')';
        });
      });
      this.$('[data-hk-sort]').value = this.sort;
      this.$('[data-hk-clear]').hidden = !KEYS.some(key => this.state[key].length);
      this.$('[data-hk-chips]').innerHTML = KEYS.flatMap(key => this.state[key].map(value => {
        const label = this.t(key)+': '+this.label(key,value);
        return '<button type="button" class="hk-chip" data-hk-remove="'+key+'" data-value="'+escape(value)+'" aria-label="'+escape(label+' '+this.t('remove'))+'">'+escape(label)+'<span aria-hidden="true">×</span></button>';
      })).join('');
    }
    render(mode) {
      this.filtered = this.products.filter(product => this.matches(product));
      if (this.sort === 'price-asc') this.filtered.sort((a,b) => a.price - b.price);
      if (this.sort === 'price-desc') this.filtered.sort((a,b) => b.price - a.price);
      if (this.sort === 'newest') this.filtered.sort((a,b) => b.id - a.id);
      this.page = Math.min(this.page, Math.max(1, Math.ceil(this.filtered.length / this.pageSize)));
      this.renderControls();
      this.$('[data-hk-count]').textContent = this.t(this.filtered.length === this.products.length ? 'products' : 'filtered', {count:this.filtered.length,total:this.products.length});
      this.renderGrid();
      this.renderPages();
      this.writeUrl(mode);
    }
    renderGrid() {
      if (!this.filtered.length) {
        this.$('[data-hk-grid]').innerHTML = '<div class="hk-empty"><p>'+escape(this.t('empty'))+'</p><button type="button" class="hk-clear" data-hk-clear>'+escape(this.t('clear'))+'</button></div>';
        return;
      }
      const money = new Intl.NumberFormat(this.lang+'-CH', {style:'currency',currency:this.currency});
      this.$('[data-hk-grid]').innerHTML = this.filtered.slice((this.page-1)*this.pageSize, this.page*this.pageSize).map(product => {
        const selectedColor = this.state.color.map(name => (product.colors || []).find(color => color.name === name)).find(Boolean);
        const image = selectedColor?.image || product.image;
        const image2 = selectedColor ? '' : product.image2;
        const url = new URL(product.url, location.origin);
        if (selectedColor) url.searchParams.set('variant', selectedColor.variant);
        const title = product.title + (selectedColor ? ' – '+selectedColor.name : '');
        return '<a class="burga-card" data-hk-product="'+escape(product.id)+'" href="'+escape(url.pathname+url.search)+'"><div class="burga-card__media'+(image2 ? ' burga-card__media--has-hover' : '')+'">'+
          (image ? '<img class="burga-card__img burga-card__img--front" src="'+escape(image)+'" alt="'+escape(title)+'" loading="lazy" width="400" height="400">' : '')+
          (image2 ? '<img class="burga-card__img burga-card__img--hover" src="'+escape(image2)+'" alt="" loading="lazy" width="400" height="400">' : '')+
          '</div><h3 class="burga-card__title">'+escape(title)+'</h3><div class="burga-card__price">'+escape((product.priceVaries ? this.t('from')+' ' : '')+money.format(product.price/100))+'</div></a>';
      }).join('');
    }
    renderPages() {
      const pages = Math.ceil(this.filtered.length / this.pageSize);
      if (pages <= 1) { this.$('[data-hk-pages]').innerHTML = ''; return; }
      const button = (page, text, label, disabled = false) => '<button type="button" data-hk-page="'+page+'"'+(disabled ? ' disabled' : '')+' aria-label="'+escape(label)+'"'+(page === this.page && !disabled ? ' aria-current="page" class="is-current"' : '')+'>'+text+'</button>';
      let html = button(this.page-1, '‹', this.t('previous'), this.page === 1);
      for (let page=1; page<=pages; page++) html += button(page, page, this.t('page')+' '+page);
      html += button(this.page+1, '›', this.t('next'), this.page === pages);
      this.$('[data-hk-pages]').innerHTML = html;
    }
  }
  customElements.define('handyketten-filters', HandykettenFilters);
})();
